import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogujratservice() {



  const cardData =
  {
    keyword: 'Pune to Gujarat Cab Service',
    heading: 'Sai Trupti Cabs: Pune to Gujarat Cab Service',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Gujarat cab services, designed to make your long-distance journey smooth and stress-free. Our fleet features well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is managed by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Gujarat destinations such as Ahmedabad. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Gujarat convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Gujarat with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Somnath Temple",
    "description": "Somnath Temple, standing proudly on the Arabian Sea’s shore, is one of India’s twelve Jyotirlingas and the eternal symbol of resilience and faith. Rebuilt multiple times after invasions, the current temple’s Chalukya-style architecture gleams with intricate carvings and a golden shikhara that rises magnificently against the ocean backdrop. The rhythmic waves seem to echo the chants of devotion, especially during the evening aarti when the temple glows in golden light. The Sound and Light Show narrates its epic past with pride and reverence. Somnath is not just a shrine but a testament to Gujarat’s unshakable spirit — where divinity meets the infinite sea."
  },
  {
    "title": "Gir National Park",
    "description": "Gir National Park, the only home of the majestic Asiatic lions, is Gujarat’s crown jewel of wildlife conservation. Spread across 1,400 square kilometers of dry deciduous forest, it offers a thrilling safari experience where lions roam freely in their natural habitat. Visitors also spot leopards, deer, antelopes, and over 300 species of birds. The forest’s golden light at dawn and the raw roar of lions make it an unforgettable adventure. Beyond wildlife, Gir reflects the harmony between nature and local Maldhari tribes. Every rustle of leaves in Gir feels like nature’s heartbeat — wild, ancient, and awe-inspiring."
  },
  {
    "title": "Rann of Kutch",
    "description": "The Rann of Kutch is Gujarat’s white desert wonder — a surreal expanse of salt flats that stretch endlessly under the sky. During the full moon, the landscape transforms into a glowing silver sea, mesmerizing travelers with its otherworldly beauty. The annual Rann Utsav celebrates this magic through music, dance, handicrafts, and desert camping. Visitors can explore colorful kutchi villages, shop for mirror-work textiles, and enjoy camel rides under starlit skies. The calm wind carries the scent of salt and folk songs across the horizon. The Rann of Kutch is not just a destination — it’s a dream painted in white and gold."
  },
  {
    "title": "Dwarkadhish Temple (Dwarka)",
    "description": "Dwarkadhish Temple, dedicated to Lord Krishna, stands as one of the Char Dham pilgrimage sites of India. Perched on the banks of the Gomti River, its five-story structure rises majestically above the holy town of Dwarka. The temple’s spire adorned with a massive flag visible from miles away sways gracefully with the sea breeze. Inside, the black stone idol of Lord Krishna exudes divine serenity. The evening aarti, accompanied by conch shells and bells, fills the air with devotion. Dwarka’s spiritual aura, coupled with its coastal charm, makes it a sacred and timeless gem of Gujarat."
  },
  {
    "title": "Statue of Unity",
    "description": "The Statue of Unity, honoring Sardar Vallabhbhai Patel, is the world’s tallest statue at 182 meters and a marvel of modern India. Standing proudly beside the Narmada River near Kevadia, it symbolizes unity, leadership, and national pride. Visitors ascend to the viewing gallery inside the statue for breathtaking views of the Sardar Sarovar Dam and Satpura hills. The surrounding complex includes museums, light shows, and eco-parks that narrate Patel’s legacy. As the sun sets, the statue glows in amber hues, inspiring awe and patriotism. It’s not just an engineering marvel — it’s the living spirit of a united India."
  },
  {
    "title": "Sabarmati Ashram",
    "description": "Sabarmati Ashram in Ahmedabad, once home to Mahatma Gandhi, is a place where peace, simplicity, and freedom converge. Situated on the banks of the Sabarmati River, the ashram served as the headquarters of India’s non-violent independence movement. Visitors can explore Hriday Kunj — Gandhi’s humble residence — and see his spinning wheel, letters, and photographs. The museum showcases the philosophy of truth and non-violence through immersive exhibits. The tranquil surroundings invite reflection and mindfulness. Walking here feels like retracing the steps of the Mahatma, where every corner whispers lessons of compassion and courage."
  },
  {
    "title": "Saputara Hill Station",
    "description": "Saputara, Gujarat’s only hill station, nestles amid the Sahyadri ranges and offers a refreshing contrast to the state’s arid plains. Covered in mist and greenery, it’s a paradise for nature lovers with scenic lakes, gardens, and viewpoints. The Ropeway, Step Garden, and Artist Village offer family-friendly recreation and cultural glimpses. During monsoon, waterfalls cascade down the hills, and clouds float at arm’s length. The peaceful air and cool climate make Saputara a perfect getaway for couples and families. It’s Gujarat’s little hill paradise — calm, cozy, and endlessly beautiful."
  },
  {
    "title": "Champaner-Pavagadh Archaeological Park",
    "description": "Champaner-Pavagadh Archaeological Park, a UNESCO World Heritage Site, showcases Gujarat’s medieval Islamic architecture blended with Hindu craftsmanship. Located near Vadodara, it houses ancient forts, stepwells, mosques, and temples dating back to the 8th–14th centuries. The Jama Masjid of Champaner, with its intricately carved pillars and domes, stands as a masterpiece of symmetry. The Pavagadh Hill Temple dedicated to Goddess Kali offers both spiritual energy and panoramic views. Exploring these ruins feels like walking through a forgotten kingdom, where stone whispers tales of faith, art, and conquest."
  },
  {
    "title": "Girnar Hill (Junagadh)",
    "description": "Girnar Hill, near Junagadh, is an ancient and sacred site revered by Hindus and Jains alike. The 10,000-step climb to the summit passes through beautiful shrines, forests, and panoramic viewpoints. Temples like Neminath Jain Temple and Amba Mata Mandir make the journey spiritually uplifting. Early morning treks reveal golden dawns and echoing chants from pilgrims. The combination of physical endurance and divine devotion makes Girnar a deeply transformative experience. It’s not just a hill — it’s a sacred staircase to heaven carved into Gujarat’s landscape."
  },
  {
    "title": "Rani ki Vav (Patan)",
    "description": "Rani ki Vav, or the Queen’s Stepwell in Patan, is Gujarat’s finest example of subterranean architecture and elegance. Built in the 11th century by Queen Udayamati in memory of her husband King Bhimdev, this UNESCO-listed structure descends seven levels deep with more than 800 exquisite sculptures. The stepwell depicts deities, apsaras, and mythological stories in intricate detail, illuminated by natural light streaming from above. During monsoon, the cool stone corridors come alive with reflections of water and carvings. Rani ki Vav isn’t just an architectural wonder — it’s poetry carved in sandstone and devotion."
  }
],



"services": [
  {
    "name": "Pune to Gujarat Cab Service",
    "description": "Book reliable Pune to Gujarat cab services for a safe, comfortable, and hassle-free journey. Choose from AC and non-AC vehicles, including Sedans, SUVs, and luxury cars. Enjoy experienced drivers familiar with long-distance routes, flexible pickup and drop points, and transparent pricing. Perfect for family trips, weekend getaways, group travel, or business journeys, with easy online booking, instant confirmation, and 24/7 customer support ensuring a smooth ride."
  },
  {
    "name": "Pune to Gujarat Taxi Service",
    "description": "Hire a Pune to Gujarat taxi for a stress-free interstate journey. Travel in well-maintained vehicles with courteous and professional drivers. Flexible schedules, one-way or round-trip options, and transparent fare policies make it ideal for tourists, business travelers, and families seeking comfort and convenience."
  },
  {
    "name": "Pune to Gujarat Car Hire",
    "description": "Rent a car from Pune to Gujarat for a personalized and comfortable travel experience. Choose from a variety of vehicles including Sedans, SUVs, and luxury options. Benefit from professional drivers, luggage assistance, AC/non-AC options, and flexible routes. Perfect for family trips, group outings, and corporate travel."
  },
  {
    "name": "AC Cab Pune to Gujarat",
    "description": "Travel comfortably with AC cab service from Pune to Gujarat. Enjoy air-conditioned vehicles, experienced drivers, flexible pickup points, and smooth, safe travel. Suitable for families, couples, and solo travelers looking for a relaxing and convenient long-distance journey."
  },
  {
    "name": "Non AC Cab Pune to Gujarat",
    "description": "Affordable non-AC cab service from Pune to Gujarat for budget-conscious travelers. Reliable drivers, well-maintained cars, and flexible pickup/drop points ensure safe, comfortable, and cost-effective travel for long distances."
  },
  {
    "name": "Innova Cab Pune to Gujarat",
    "description": "Book spacious and comfortable Innova cabs from Pune to Gujarat. Ideal for families or groups, featuring AC comfort, ample legroom, luggage space, and experienced drivers. Enjoy smooth travel on highways and city roads with a stress-free journey."
  },
  {
    "name": "Ertiga Cab Pune to Gujarat",
    "description": "Affordable and convenient group travel with Ertiga cabs from Pune to Gujarat. Choose AC/non-AC options, enjoy comfortable seating, ample luggage space, and professional drivers ensuring a safe and enjoyable ride. Perfect for friends, families, or corporate groups."
  },
  {
    "name": "Luxury Cab Pune to Gujarat",
    "description": "Travel in style with luxury cab services from Pune to Gujarat. Premium Sedans and SUVs with elegant interiors, AC service, and professional chauffeurs make it ideal for VIP guests, business executives, or special occasions. Experience comfort, safety, and prestige throughout the journey."
  },
  {
    "name": "Affordable Cab Pune to Gujarat",
    "description": "Get pocket-friendly Pune to Gujarat cab services with transparent fares, AC/non-AC options, and professional drivers. Flexible timings, easy booking, and reliable service make it perfect for solo travelers, students, and small families looking for value-for-money travel."
  },
  {
    "name": "Pune to Gujarat Outstation Cab",
    "description": "Reliable outstation cab service from Pune to Gujarat ideal for weekend trips, sightseeing, or long stays. Choose from a variety of vehicles, enjoy AC/non-AC comfort, flexible bookings, and safe travel with experienced drivers for a hassle-free interstate journey."
  },
  {
    "name": "Pune to Gujarat One Way Cab",
    "description": "Book one-way cabs from Pune to Gujarat at affordable rates. Point-to-point travel, clean vehicles, professional drivers, and flexible pickups make it ideal for travelers heading to Gujarat without return plans."
  },
  {
    "name": "Pune to Gujarat Drop Cab",
    "description": "One-way drop cab service from Pune to Gujarat with flexible timings, AC/non-AC options, and professional drivers. Enjoy a smooth, comfortable ride perfect for single transfers, business trips, or leisure travel."
  },
  {
    "name": "Corporate Cab Pune to Gujarat",
    "description": "Premium corporate cab hire from Pune to Gujarat with executive vehicles, professional chauffeurs, and flexible travel schedules. Ideal for conferences, business meetings, client visits, and corporate events, offering comfort, punctuality, and reliability."
  },
  {
    "name": "Wedding Cab Pune to Gujarat",
    "description": "Elegant wedding cab service from Pune to Gujarat with luxury interiors, AC comfort, professional drivers, and on-time pickups. Perfect for bride/groom transfers, guest transport, and event logistics with complete reliability and style."
  },
  {
    "name": "Online Cab Booking Pune to Gujarat",
    "description": "Book your Pune to Gujarat cab online with instant confirmation, secure payment, and transparent fares. Choose from Sedans, Innova, and Ertiga for a convenient, stress-free journey. Ideal for last-minute travel, weekend trips, or planned travel with complete convenience."
  }
],
"tableData": [
  ["Pune to Gujarat Cab Service", "Pune to Gujarat Taxi Service"],
  ["Pune to Gujarat Car Hire", "AC Cab Pune to Gujarat"],
  ["Non AC Cab Pune to Gujarat", "Innova Cab Pune to Gujarat"],
  ["Ertiga Cab Pune to Gujarat", "Luxury Cab Pune to Gujarat"],
  ["Affordable Cab Pune to Gujarat", "Pune to Gujarat Outstation Cab"],
  ["Pune to Gujarat One Way Cab", "Pune to Gujarat Drop Cab"],
  ["Online Cab Booking Pune to Gujarat", "Corporate Cab Pune to Gujarat"],
  ["Wedding Cab Pune to Gujarat", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Gujarat Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs provides reliable and comfortable cab service from Pune to Gujarat — ideal for business travel, family trips, and interstate tours across major Gujarat cities."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Enjoy clear, all-inclusive fares for Pune to Gujarat cabs — no hidden charges or last-minute surprises, ensuring a stress-free travel experience."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or premium cars according to your group size, comfort, and budget for your long-distance Pune–Gujarat trip."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our experienced drivers are well-versed with long highway routes between Pune and major Gujarat cities like Ahmedabad, Surat, and Vadodara — ensuring a safe and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickups from any part of Pune — including airport, home, or office — and drop-offs anywhere in Gujarat, tailored to your itinerary."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All Sai Trupti cabs are regularly serviced, sanitized, and maintained to provide a comfortable and worry-free interstate travel experience."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our support team is available 24/7 to help you with bookings, travel planning, or assistance throughout your Pune to Gujarat cab journey."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Gujarat cab quickly via phone, WhatsApp, or our website — get instant confirmation and prompt vehicle dispatch for a seamless travel experience."
  }
]























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Pune to Gujarat cab services?',
    answer: 'Yes, Sai Trupti Cabs provides reliable and affordable Pune to Gujarat cab services for one way, round trips, and business or family travel.',
  },
  {
    question: 'How can I book a Pune to Gujarat cab with Sai Trupti Cabs?',
    answer: 'Booking your Pune to Gujarat cab is simple! Visit our website, use our mobile app, or contact our 24×7 customer support team for quick booking assistance.',
  },
  {
    question: 'What types of cabs are available from Pune to Gujarat?',
    answer: 'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers—perfect for individual, family, or group trips.',
  },
  {
    question: 'Are Sai Trupti Cabs drivers experienced for Pune to Gujarat routes?',
    answer: 'Yes, our drivers are highly experienced, courteous, and familiar with all major routes from Pune to different parts of Gujarat such as Ahmedabad, Surat, Vadodara, and Rajkot.',
  },
  {
    question: 'Can I book a cab for sightseeing or intercity travel within Gujarat?',
    answer: 'Of course! Sai Trupti Cabs offers flexible packages for sightseeing or intercity travel across Gujarat, including Ahmedabad, Dwarka, Somnath, and Statue of Unity tours.',
  },
  {
    question: 'Is the Pune to Gujarat cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs operates 24×7 Pune to Gujarat cab services, so you can travel at your convenience—day or night.',
  },
  {
    question: 'What are the Pune to Gujarat cab fares?',
    answer: 'Our Pune to Gujarat cab fares start from ₹8,000 for sedans and ₹10,000–₹12,000 for SUVs or Innova Crysta, depending on the destination city and trip type.',
  },
  {
    question: 'What payment options are available for Pune to Gujarat cab bookings?',
    answer: 'We accept multiple payment modes including UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Gujarat cabs?',
    answer: 'All our cabs are sanitized before every journey, and our drivers maintain high hygiene and safety standards throughout the trip.',
  },
  {
    question: 'Is customer support available during the Pune to Gujarat cab journey?',
    answer: 'Yes, our 24×7 customer support team is available to help you at every stage of your Pune to Gujarat trip.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ketan Shah',
    feedback: 'Had an excellent Pune to Ahmedabad trip with Sai Trupti Cabs. The driver was very professional, and the car was neat and comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Nisha Patel',
    feedback: 'Sai Trupti Cabs provided an outstanding Pune to Surat cab service. Smooth ride, courteous driver, and very punctual!',
    rating: 5,
  },
];























































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];
















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Gujarat Cab Service",
  "image": "https://saitrupticabs.com/assets/images/pune-to-gujarat-cab.jpg", // Replace with actual image URL
  "description": "Book cabs from Pune to Gujarat with Sai Trupti Cabs. Choose AC, Non-AC, Innova, Ertiga, luxury rides, one-way trips, drop services, corporate travel, weddings, or outstation trips. Affordable 24x7 online booking available.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000", // Example price, adjust as per actual rates
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-gujarat-cab-booking"
  }
};






  return (
    <div>
<Helmet>
  <title>Pune to Gujarat Cab Service | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book cabs from Pune to Gujarat with Sai Trupti Cabs. Choose AC, Non-AC, Innova, Ertiga, luxury rides, one-way trips, drop services, corporate travel, weddings, or outstation trips. Affordable 24x7 online booking available." 
  />
  <meta 
    name="keywords" 
    content="Pune to Gujarat Cab Service, Pune to Gujarat Taxi Service, Pune to Gujarat Car Hire, AC Cab Pune to Gujarat, Non AC Cab Pune to Gujarat, Innova Cab Pune to Gujarat, Ertiga Cab Pune to Gujarat, Luxury Cab Pune to Gujarat, Affordable Cab Pune to Gujarat, Pune to Gujarat Outstation Cab, Pune to Gujarat One Way Cab, Pune to Gujarat Drop Cab, Corporate Cab Pune to Gujarat, Wedding Cab Pune to Gujarat, Online Cab Booking Pune to Gujarat" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/69.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogujratservice;